<div
  class="video-container"
  [class.active]="isActive"
  (click)="onPlayerClick()"
>

  <video
  #videoElement
  autoplay
  muted
  playsinline>
</video>

  <!-- Device name -->
  <div class="device-name" [class.visible]="showControls">
    {{ deviceName }}
  </div>

  <!-- Controls -->
  <div
    class="controls"
    [class.visible]="showControls"
    (click)="$event.stopPropagation()"
  >

    <div class="left-controls">
      <button (click)="toggleMute()">
        {{ isMuted ? '🔇' : '🔊' }}
      </button>

      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        [value]="volume"
        (input)="setVolume($event)"
      />
    </div>

    <div class="right-controls">
      <button (click)="togglePiP()">🗗</button>
      <button (click)="toggleFullscreen()">⛶</button>
    </div>

  </div>

</div>